"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateExperimentRequestToJSON = exports.CreateExperimentRequestFromJSONTyped = exports.CreateExperimentRequestFromJSON = exports.instanceOfCreateExperimentRequest = void 0;
var runtime_1 = require("../runtime");
var ExperimentType_1 = require("./ExperimentType");
var HoldoutLevel_1 = require("./HoldoutLevel");
var SurveyQuestion1_1 = require("./SurveyQuestion1");
/**
 * Check if a given object implements the CreateExperimentRequest interface.
 */
function instanceOfCreateExperimentRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateExperimentRequest = instanceOfCreateExperimentRequest;
function CreateExperimentRequestFromJSON(json) {
    return CreateExperimentRequestFromJSONTyped(json, false);
}
exports.CreateExperimentRequestFromJSON = CreateExperimentRequestFromJSON;
function CreateExperimentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'type': (0, ExperimentType_1.ExperimentTypeFromJSON)(json['type']),
        'name': json['name'],
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'eligibilityCampaignIds': !(0, runtime_1.exists)(json, 'eligibility_campaign_ids') ? undefined : json['eligibility_campaign_ids'],
        'isTest': !(0, runtime_1.exists)(json, 'is_test') ? undefined : json['is_test'],
        'market': !(0, runtime_1.exists)(json, 'market') ? undefined : json['market'],
        'holdoutLevel': !(0, runtime_1.exists)(json, 'holdout_level') ? undefined : (0, HoldoutLevel_1.HoldoutLevelFromJSON)(json['holdout_level']),
        'holdoutPercent': !(0, runtime_1.exists)(json, 'holdout_percent') ? undefined : json['holdout_percent'],
        'markets': !(0, runtime_1.exists)(json, 'markets') ? undefined : json['markets'],
        'languages': !(0, runtime_1.exists)(json, 'languages') ? undefined : json['languages'],
        'surveyQuestions': !(0, runtime_1.exists)(json, 'survey_questions') ? undefined : (json['survey_questions'].map(SurveyQuestion1_1.SurveyQuestion1FromJSON)),
    };
}
exports.CreateExperimentRequestFromJSONTyped = CreateExperimentRequestFromJSONTyped;
function CreateExperimentRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'type': (0, ExperimentType_1.ExperimentTypeToJSON)(value.type),
        'name': value.name,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'eligibility_campaign_ids': value.eligibilityCampaignIds,
        'is_test': value.isTest,
        'market': value.market,
        'holdout_level': (0, HoldoutLevel_1.HoldoutLevelToJSON)(value.holdoutLevel),
        'holdout_percent': value.holdoutPercent,
        'markets': value.markets,
        'languages': value.languages,
        'survey_questions': value.surveyQuestions === undefined ? undefined : (value.surveyQuestions.map(SurveyQuestion1_1.SurveyQuestion1ToJSON)),
    };
}
exports.CreateExperimentRequestToJSON = CreateExperimentRequestToJSON;
